import { Component } from '@angular/core';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'di-authentication-error',
  templateUrl: './authentication-error.component.html',
  styleUrl: './authentication-error.component.scss',
  standalone: false,
})
export class AuthenticationErrorComponent {
  backToHome() {
    window.location.href = environment.vismaHomeUrl;
  }
}
